import type {BioIconProps} from '../../icons/common-types'

export default function BesteExpertenwahlLogo({...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-4 text-2xl font-semibold text-white tablet:text-base">
      <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          d="M9.57018 1.05962C9.86954 0.138307 11.1729 0.138309 11.4723 1.05962L13.1032 6.07887C13.237 6.4909 13.621 6.76986 14.0542 6.76986H19.3318C20.3005 6.76986 20.7033 8.00947 19.9195 8.57887L15.6499 11.6809C15.2994 11.9356 15.1528 12.387 15.2866 12.799L16.9175 17.8182C17.2169 18.7395 16.1624 19.5057 15.3787 18.9363L11.109 15.8342C10.7585 15.5795 10.2839 15.5795 9.93345 15.8342L5.66382 18.9363C4.88011 19.5057 3.82563 18.7395 4.12498 17.8182L5.75584 12.799C5.88971 12.387 5.74305 11.9356 5.39256 11.6809L1.12293 8.57887C0.339217 8.00947 0.741994 6.76986 1.71072 6.76986H6.98827C7.4215 6.76986 7.80546 6.4909 7.93933 6.07887L9.57018 1.05962Z"
          fill="#FB923C"
        />
      </svg>

      <span>Beste Experten Wahl</span>
    </div>
  )
}
